import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TrainingService } from '../training.service';

@Component({
  selector: 'app-sel-user',
  templateUrl: './sel-user.component.html',
  styleUrls: ['../sel-task/sel-task.component.scss', './sel-user.component.scss']
})
export class SelUserComponent {
  _users: any = {}
  users_ids: string[] = []
  expand_id: string = ""
  expand_tasks_keys: string[] = []
  @Input() set users(us: any[]) {
    if (us) {
      this._users = us
      this.users_ids = Object.keys(this._users)
    }
  }
  @Output() sel_user: EventEmitter<string> = new EventEmitter();
  @Output() close: EventEmitter<void> = new EventEmitter();

  task_name: string = ""
  constructor(
    public training_sevice: TrainingService,
  ) {

  }
  selUser(user_id: string) {
    this.sel_user.emit(user_id)
    this.close.emit()
  }
  closeIt() {
    this.close.emit()
  }
  toogleExp($event: any, id: string) {
    $event.stopPropagation()
    if (id == this.expand_id) {
      this.expand_id = ""
    } else {
      this.expand_id = id
      this.expand_tasks_keys = Object.keys(this._users[id].tasks)
    }

  }
}
